import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    resTitle: {
        name: () => '系统响应',
    },
})
